import { memo } from "react"
import { Svg, Path } from "react-native-svg"
import { Colors } from "src/constants/Colors"

export const ChevronDownIcon = memo(() => (
  <Svg width="12" height="7.4" viewBox="0 0 12 7.4">
    <Path data-name="↳Color" d="M10.59 0 6 4.574 1.41 0 0 1.408 6 7.4l6-5.992z" fill={Colors.orange} />
  </Svg>
))
